import { Avatar, Box } from "@mui/material";
import PropTypes from "prop-types";
import { getImageSrc } from "services/utils";

const EmployeeAvatar = ({ photo, sx, boxSx }) => {
  return (
    <Box display="flex" justifyContent="center" alignItems="center" mb={1} {...boxSx}>
      <Avatar
        src={getImageSrc(photo)}
        alt="Employee Photo"
        sx={{
          width: 80,
          height: 80,
          bgcolor: "white", // Set background to white
          "& .MuiAvatar-img": {
            width: "100%",
            height: "100%",
          },
          ...sx,
        }}
      />
    </Box>
  );
};

EmployeeAvatar.propTypes = {
  photo: PropTypes.any, // Allow null or undefined values
  sx: PropTypes.object,
  boxSx: PropTypes.object,
};

export default EmployeeAvatar;
